export class EmailTemplateApiModel {
    emailTemplateID: number;
    campaignID: number;
    emailContent: string;
    title: string;
    author: string;
    createdOn: string;
    lastEditedBy: string;
    lastEditedOn: string;
}